function defaultComputeGap(density) {
  switch (density) {
    case "collapsed":
      return 0;
    case "compact":
      return 0.25;
    case "comfortable":
      return 1;
    case "standard":
    default:
      return 0.5;
  }
}
export {
  defaultComputeGap
};
//# sourceMappingURL=defaultComputeGap.js.map
